// extracted by mini-css-extract-plugin
export default {"allTasksAndRecordsContainer":"style_allTasksAndRecordsContainer__ltUuo","byType":"style_byType__Eb6dq"};